/** Raw digits only (max 4): MMYY. */
export function normalizeCardExpiryDigits(input: string): string {
    return input.replace(/\D/g, "").slice(0, 4);
}

/** Display value with fixed slash after month: `12/34`. */
export function formatCardExpiryDisplay(digits: string): string {
    const normalized = normalizeCardExpiryDigits(digits);
    if (normalized.length <= 2) {
        return normalized;
    }

    return `${normalized.slice(0, 2)}/${normalized.slice(2)}`;
}

/** Expands YY to 20YY for payment gateways expecting four-digit year. */
export function expandCardExpiryYear(twoDigitYear: string): string {
    const yy = twoDigitYear.replace(/\D/g, "").slice(0, 2);
    if (yy.length !== 2) {
        return "";
    }

    return `20${yy}`;
}

export function parseCardExpiryParts(digits: string): { expiryMonth: string; expiryYear: string } {
    const normalized = normalizeCardExpiryDigits(digits);
    const expiryMonth = normalized.slice(0, 2);
    const yy = normalized.slice(2, 4);

    return {
        expiryMonth,
        expiryYear: expandCardExpiryYear(yy),
    };
}

export const CARD_EXPIRY_INPUT_PLACEHOLDER = "__/__";
